// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_GROWL_YOUR_USERNAME_WILL_BE_SHOWN = "V t\u00e9to diskuzi se tvoje p\u0159ihla\u0161ovac\u00ed jm\u00e9no bude zobrazovat.";
export const FORUM_GROWL_YOUR_USERNAME_WONT_BE_SHOWN = "V t\u00e9to diskuzi se tvoje p\u0159ihla\u0161ovac\u00ed jm\u00e9no nebude zobrazovat.";
export const FORUM_POST_DRAFT_FOR_TICKET_INTRO = "Pros\u00edm o zalo\u017een\u00ed diskuze bez m\u00e9 \u00fa\u010dasti. Text diskuze m\u00e1 b\u00fdt:";
